import { defineStore } from "pinia";
import { isSandbox } from "~/utils/common";
import { getCmsConfig } from "~/api/api";
import { getChannel } from "~/utils/getChannel";

export const useCmsDataStore = defineStore(
	"cmsData",
	() => {
		const cmsConfig = ref({});

		async function updateCmsConfig() {
			try {
				const channel = getChannel();

				// 客户端环境下读取缓存
				if (import.meta.client) {
					const cachedData = getCmsfeDataToStorage(channel);
					if (cachedData) {
						cmsConfig.value = cachedData;
						return cachedData;
					}
				}

				const res = await getCmsConfig(isSandbox ? 1 : 0, channel);

				if (res.code === 1) {
					let data = res.data.fields;

					// 数据处理
					if (data.google_pixel_code) {
						data.google_pixel_code = JSON.parse(data.google_pixel_code);
					}
					if (data.fb_px_code_id) {
						data.fb_px_code_id = JSON.parse(data.fb_px_code_id);
					}

					// 客户端环境下设置缓存
					if (import.meta.client) {
						setCmsfeDataToStorage(channel, res.data);
					}

					cmsConfig.value = data;
					return data;
				}
			} catch (error) {
				console.error("cmsConfigError", error);
				throw error;
			}
		}

		function getCmsfeDataToStorage(channel) {
			const TIMEOUT = 5 * 60 * 1000;
			const now = Date.now();
			const storageKey = `tw_config_${channel}`;

			try {
				const storedData = localStorage.getItem(storageKey);
				if (!storedData) return null;

				const cmsfeData = JSON.parse(storedData);
				if (now - cmsfeData.now <= TIMEOUT) {
					return cmsfeData.fields;
				}
			} catch (e) {
				console.warn("Failed to parse stored CMS data", e);
			}
			return null;
		}

		function setCmsfeDataToStorage(channel, data) {
			const storageKey = `tw_config_${channel}`;
			try {
				const storageData = {
					...data,
					now: Date.now(),
				};
				localStorage.setItem(storageKey, JSON.stringify(storageData));
			} catch (e) {
				console.warn("Failed to store CMS data", e);
			}
		}

		return {
			cmsConfig,
			updateCmsConfig,
		};
	},
	{
		persist: {
			storage: import.meta.client ? localStorage : undefined,
			paths: ["cmsConfig"],
		},
	}
);
